const flags = {
    // values
    UNDEFINED: undefined,
    WAITING: 'WAITING',
    LOADING: 'WAITING',
    SUCCESS: 'SUCCESS',
    OK: 'SUCCESS',
    ERROR: 'ERROR',
    TRUE: true,
    FALSE: false,

    // flag names
    SUPERADMIN_UPDATING_CONFIG_FILE: 'SUPERADMIN_UPDATING_CONFIG_FILE'
}

export default flags



// WEBPACK FOOTER //
// src/utils/flags.js